'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, $analytics, $cookieStore, $location, Config) {
    this.Auth = Auth;
    this.$state = $state;
    this.$analytics = $analytics;
    this.$cookieStore = $cookieStore;
    this.$location = $location;
    this.signUpDeactivated = Config.getModuleConfig(Config.Modules.SignUp).getDeactivated();
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();

    this.preHookHtml = Config.getModuleConfig(Config.Modules.SignUp).getPreHookHtml();
    this.postHookHtml = Config.getModuleConfig(Config.Modules.SignUp).getPostHookHtml();
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email.toLowerCase(),
        password: this.user.password
      })
        .then(() => {
          if (this.$analytics) {
            this.$analytics.setUsername(this.user.email);
          }

          if (typeof this.$cookieStore.get('returnUrl') != 'undefined' && this.$cookieStore.get('returnUrl') != '')
          {
            this.$location.path(this.$cookieStore.get('returnUrl'));
            this.$cookieStore.remove('returnUrl');
          }
          else
          {
            // Logged in default if no returnUrl defined: redirect to home
            this.$state.go('home');
          }
        })
        .catch(err => {
          this.errors.login = err.message || err[0].message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js